import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { type SimpleSelectOption } from '@workwave-tidal/core/components'

import { selectCompaniesAsArray } from '@/features/domain/company'

import { useTexts } from './useTexts'

export function useDropdownOptions(NONE_OPTION: string): SimpleSelectOption<string>[] {
  const companies = useSelector(selectCompaniesAsArray)
  const texts = useTexts()

  return useMemo(() => {
    const noneOption = { value: NONE_OPTION, label: texts.none }
    return [noneOption, ...companies.map(mapCompanyToDropdownItem)]
  }, [companies, texts])
}

function mapCompanyToDropdownItem(
  company: uui.domain.client.rm.Company,
): SimpleSelectOption<string> {
  return {
    value: company.id,
    label: company.name,
    disabled: !company.enabled,
  }
}
